export default [
  { name: 'Home', url: '/' },
  { name: 'History', url: '/history' },
  { name: 'Setting', url: '/setting' },
] as const;
